import {
  Card,
  Container,
  StackSeparator,
  Flex,
  Icon,
  Stack,
  Text,
  Heading,
} from '@chakra-ui/react';
import {
  UsersIcon,
  TicketIcon,
  Cog6ToothIcon,
  PencilSquareIcon,
  CommandLineIcon,
  Squares2X2Icon,
  RectangleStackIcon,
} from '@heroicons/react/24/outline';
import { NavLink, useParams } from 'react-router-dom';
import useWorkspace from '@/lib/hooks/use-workspace';

interface Props {
  text: string;
  icon: any;
}

const NavItem = ({ text, icon }: Props) => {
  return (
    <Stack direction={'row'} align={'center'}>
      <Flex w={8} h={8} align={'center'} justify={'center'} rounded={'full'} bg={'brand.50'}>
        <Icon as={icon} color={'brand.500'} w={4} h={4} />
      </Flex>
      <Text fontWeight={500}>{text}</Text>
    </Stack>
  );
};

export default function Settings() {
  const { workspaceId } = useParams();
  const { workspace } = useWorkspace();

  return (
    <Card.Root minH={'100vh'} mx={'auto'} width={{ md: '90%' }} maxW={'6xl'}>
      <Card.Header>
        <Card.Title fontSize='3xl' textAlign='center' mb={4}>
          <Icon as={Cog6ToothIcon} w={8} h={8} mr={2} />
          Settings
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Container maxW={'2xl'}>
          <Heading as={'h2'} size={'xl'} mb={6}>
            {workspace?.name}
          </Heading>
          <Stack gap={4} separator={<StackSeparator />}>
            <NavLink to={`/${workspaceId}/account/edit`}>
              <NavItem text={'Update this workspace'} icon={PencilSquareIcon} />
            </NavLink>
            <NavLink to={`/${workspaceId}/users`}>
              <NavItem text={'Users'} icon={UsersIcon} />
            </NavLink>
            <NavLink to={`/${workspaceId}/billing`}>
              <NavItem text={'Billing'} icon={TicketIcon} />
            </NavLink>
            <NavLink to={`/${workspaceId}/fields`}>
              <NavItem text={'Fields'} icon={CommandLineIcon} />
            </NavLink>
            <NavLink to={`/${workspaceId}/content-types`}>
              <NavItem text={'Content libraries'} icon={Squares2X2Icon} />
            </NavLink>
            <NavLink to={`/${workspaceId}/collection-types`}>
              <NavItem text={'Content collections'} icon={RectangleStackIcon} />
            </NavLink>
          </Stack>
        </Container>
      </Card.Body>
    </Card.Root>
  );
}
